import React from 'react';
import { Spinner } from './Spinner';
import styles from './LoadingButton.module.css';

interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  loadingText?: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger';
  fullWidth?: boolean;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading = false,
  loadingText,
  children,
  variant = 'primary',
  fullWidth = false,
  disabled,
  className = '',
  ...props
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      {...props}
      disabled={isDisabled}
      className={`${styles.button} ${styles[variant]} ${fullWidth ? styles.fullWidth : ''} ${isDisabled ? styles.disabled : ''} ${className}`}
      aria-busy={isLoading}
    >
      {isLoading && (
        <span className={styles.spinnerWrapper}>
          <Spinner size="small" color="white" />
        </span>
      )}
      <span className={isLoading ? styles.loadingText : ''}>
        {isLoading && loadingText ? loadingText : children}
      </span>
    </button>
  );
};
